import React from "react";

import norecord from "../../assets/images/message-remove.png";
import PlusIMgDark from "../../assets/images/plusDark.png";
// import { useSelector } from "react-redux";
import MessageGroupItem from "./MessageGroupItem";

const MessageGroupsList = ({
  data,
  handleRemoveMessageGroups,
  handleEditMessageGroups,
  handleOpenForm,
}) => {
  return (
    <div id="tab-1" className="tab-content">
      <div className="tableInfo">
        <div className="listTables">
          {!data ||
            (data?.length > 0 && (
              <ul className="individualRow tableHead">
                <li className="mesageSegmentTitleHead">Title</li>
                <li className="messageSegmentBlocksHead">Message Set</li>
                <li className="messageSegmentActionHead">Action</li>
              </ul>
            ))}
          {!data ||
            (data?.length < 1 && (
              <ul className="individualRow tableContent noRecordsWraper">
                <li className="noRecord messageWrater">
                  <p>No Message Groups created.</p>
                  <span className="noImageWraper">
                    <img src={norecord} alt="" />
                  </span>
                  <button
                    style={{ margin: "25px auto" }}
                    className="createButton Lists"
                    id="autometion-create-btn"
                    onClick={handleOpenForm}
                  >
                    <img src={PlusIMgDark} className="plusImg" alt="" />
                    Add Groups
                  </button>
                </li>
              </ul>
            ))}
          {data?.map((message) => {
            return (
              <MessageGroupItem
                key={message?._id}
                message={message}
                handleRemoveMessageGroups={handleRemoveMessageGroups}
                handleEditMessageGroups={handleEditMessageGroups}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MessageGroupsList;
